import type { MouseEvent } from "react";
import type { DesignPage } from "./api";

export function pageStatus(page: DesignPage) {
  return page.removal_pending
    ? "Removal pending"
    : page.has_unpublished_changes
      ? "Unpublished changes"
      : page.status === "published"
        ? "Published"
        : "Draft";
}

/** Keep nested controls and text selection independent of row navigation. */
export function openWorkspaceRow(
  event: MouseEvent<HTMLElement>,
  open: () => void,
) {
  if (event.defaultPrevented || event.button !== 0) return;
  if (
    !(event.target instanceof Element) ||
    event.target.closest(
      'button,a,input,label,select,textarea,summary,details,[role="menuitem"],[role="menuitemradio"],[role="switch"],[role="checkbox"]',
    )
  )
    return;
  if (window.getSelection()?.isCollapsed === false) return;
  event.currentTarget
    .querySelector<HTMLButtonElement>("[data-row-open]")
    ?.focus({ preventScroll: true });
  open();
}
